import * as Sentry from '@sentry/react';
import { useState } from 'react';
import { CookieUtils } from '../../lib/storage/cookies.util';

export type OrganizationIdType = string | undefined;
const keyName = 'organizationid';
export const ORGANIZATION_ID_LOCAL_STORAGE_KEY = keyName;

export const useOrganizationId = (): [OrganizationIdType, (newValue: string) => void] => {
  const [storedValue, setStoredValue] = useState((): OrganizationIdType => {
    try {
      const value =
        window.localStorage.getItem(keyName) || CookieUtils.getCookie(keyName) || null;
      if (value) {
        return value.includes('"') ? JSON.parse(value) : value;
      }

      return undefined;
    } catch (err) {
      Sentry.captureMessage(`Error parsing cookie: ${keyName}`, 'error');
      Sentry.captureException(err);
      return undefined;
    }
  });

  const setValue = (newValue?: string) => {
    try {
      if (newValue && newValue.length > 0) {
        window.localStorage.setItem(keyName, newValue);
      } else {
        window.localStorage.removeItem(keyName);
      }
    } catch (err) {
      Sentry.captureMessage(`Error setting cookie: ${keyName}`, 'error');
      Sentry.captureException(err);
    }
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};
